import React, { useEffect, useRef } from "react";
import { Outlet } from "react-router";
import { Header } from "./header";
import { Footer } from "./footer";

export default function RouteLayout() {
  const ltCssRef = useRef(null);
  const themeRef = useRef(null);

  const handleCssLoad = () => {
    document.body.style.display = "block";
  };

  const handleCssLoadError = () => {
    console.error("Failed to load CSS");
    document.body.style.display = "block"; // Provide fallback styles here
  };

  useEffect(() => {
    const ltCssLink = ltCssRef.current;

    // const themeLink = themeLinkRef.current;
    // switch (theme) {
    //   case "darkMode":
    //     themeLink.href = `${THEME_OVERRIDES}/darkMode.css`;
    //     break;
    //   default:
    //     themeLink.href = REALM_THEME
    //       ? REALM_THEME
    //       : process.env.REACT_APP_;
    //     break;
    // }
    // setThemeLink(themeLink.href);

    if (ltCssLink) {
      // Add event listeners
      ltCssLink.addEventListener("load", handleCssLoad);
      ltCssLink.addEventListener("error", handleCssLoadError);
    } else {
      // Handle the error case where links are not available
      handleCssLoadError();
    }

    // Cleanup the event listeners on unmount
    return () => {
      if (ltCssLink) {
        ltCssLink.removeEventListener("load", handleCssLoad);
        ltCssLink.removeEventListener("error", handleCssLoadError);
      }
    };
  }, []);
  // }, [theme]);

  return (
    <div className="chroma-wrapper">
      <link
        ref={ltCssRef}
        rel="stylesheet"
        href={process.env.REACT_APP_LT_CSS}
      />
      <Header />
      <main className="chroma-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
